import instance from 'api';
import { IDynamicTableParams } from 'components/DynamicTable';
import { IAvailableColumnModel, IAvailableGroupColumnModel } from 'interfaces';
import { IKPIIndicator } from './interfaces';

export const getKPIIndicatorList = (data: IDynamicTableParams) => {
  return instance()
    .post<IKPIIndicator[]>('/kpi/indicator/list', data)
    .then((response) => response.data);
};

export const getKPIIndicatorListNotDeleted = () => {
  return instance()
    .post<IKPIIndicator[]>('/kpi/indicator/listNotDeleted')
    .then((response) => response.data);
};

export const getKPIIndicatorAvailableColumns = () => {
  return instance()
    .post<IAvailableColumnModel[]>('/kpi/indicator/availableColumns')
    .then((response) => response.data);
};

export const getKPIIndicatorAvailableGroupColumns = () => {
  return instance()
    .post<IAvailableGroupColumnModel[]>('/kpi/indicator/availableGroupColumns')
    .then((response) => response.data);
};

export const loadKPIIndicator = (kpiIndicatorId: number) => {
  return instance()
    .post<IKPIIndicator>(`/kpi/indicator/load`, { kpiIndicatorId })
    .then((response) => response.data);
};

export const createKPIIndicator = (kpiIndicator: IKPIIndicator) => {
  return instance()
    .post<IKPIIndicator>(`/kpi/indicator/create`, kpiIndicator)
    .then((response) => response.data);
};

export const updateKPIIndicator = (kpiIndicator: IKPIIndicator) => {
  return instance()
    .post<IKPIIndicator>(`/kpi/indicator/update`, kpiIndicator)
    .then((response) => response.data);
};

export const archiveKPIIndicator = (kpiIndicatorId: number) => {
  return instance()
    .post(`/kpi/indicator/archive/${kpiIndicatorId}`)
    .then((response) => response.data);
};

export const recoverKPIIndicator = (kpiIndicatorId: number) => {
  return instance()
    .post(`/kpi/indicator/recover/${kpiIndicatorId}`)
    .then((response) => response.data);
};
